import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
  public title = '';
  public message = '';
  public modalId = 'alert-modal';
  constructor() { }

  ngOnInit() {
  }

  public show(title: string, message: string = ''): void {
    this.title = title;
    this.message = message;
    $('#' + this.modalId).modal('show');
  }

  public hide(): void {
    $('#' + this.modalId).modal('hide');
  }
  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }
}
